//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.js";
import "../no/Builder.js";
let d=[[[0,"ExternalReference",1,0],[0,"RunToSimTime",1,0],[0,"Snapshot",1,"SIM.Snapshot",0]],[[["snapshotName","setupName"],"GetSnapshot",{R_:{snapshot:"SIM.Snapshot"}},2,1],[["snapshotTags","sourceComps"],"SetExternalSnapshotSelection",{},2,0],[["count"],"GetExternalSnapshots",{R_:{snapshot:"SIM.Snapshot[]"}},0,0]],[]];
SPLM.SIM.LoadSnapshotBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.LoadSnapshotBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;